import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { TrackerOverviewActions } from '../actions';
import {
  TrackerOverviewAnalyticQuery,
  TrackerOverviewQueryCollectionItem
} from '../states/tracker-overview.state.interface';
import { trackerState } from '../tracker.state';

// Overview action handlers - these return `on` functions that can be used in createReducer
export const trackerOverviewHandlers: Array<
  Parameters<typeof createReducer<typeof trackerState>>[1]
> = [
  on(
    TrackerOverviewActions.changeTrackerOverviewTimeRange,
    (state, payload) => {
      return {
        ...state,
        overview: {
          ...state.overview,
          selectedTimeRange: payload.timeRange
        }
      };
    }
  ),
  on(
    TrackerOverviewActions.fetchAllTrackerOverviewAnalytics,
    (state, payload) => {
      // Supported metrics for analytics
      const metrics = payload.metricCodes;

      const newQueriesCollection: Array<TrackerOverviewAnalyticQuery> =
        cloneDeep(state.overview.queriesCollection);
      for (const metric of metrics) {
        const type =
          `${metric}-analytics-${payload.timeRange}` as TrackerOverviewQueryCollectionItem['type'];
        const queryIndex = newQueriesCollection.findIndex(
          (item) => item.type === type
        );
        if (queryIndex !== -1) {
          const prevQuery = newQueriesCollection[queryIndex];
          newQueriesCollection[queryIndex] = {
            ...prevQuery,
            loading: true,
            error: undefined,
            fetchCount: prevQuery.fetchCount + 1
          };
        } else {
          newQueriesCollection.push({
            type: type as any,
            loading: true,
            error: undefined,
            fetchCount: 1,
            data: {
              metricTimeline: [],
              metricDetailScore: []
            }
          });
        }
      }

      return {
        ...state,
        overview: {
          ...state.overview,
          queriesCollection: newQueriesCollection
        }
      };
    }
  ),
  on(
    TrackerOverviewActions.fetchAllTrackerOverviewAnalyticsFailed,
    (state, payload) => {
      const queryIndex = state.overview.queriesCollection.findIndex(
        (item) => item.type === payload.queryType
      );
      if (queryIndex !== -1) {
        const newQueriesCollection = [...state.overview.queriesCollection];
        newQueriesCollection[queryIndex] = {
          ...newQueriesCollection[queryIndex],
          loading: false,
          error: payload.error
        };
        return {
          ...state,
          overview: {
            ...state.overview,
            queriesCollection: newQueriesCollection
          }
        };
      }
      return state;
    }
  ),
  on(
    TrackerOverviewActions.fetchAllTrackerOverviewAnalyticsSuccess,
    (state, payload) => {
      const queryIndex = state.overview.queriesCollection.findIndex(
        (item) => item.type === payload.queryType
      );
      if (queryIndex >= 0) {
        const newQueriesCollection = [...state.overview.queriesCollection];
        newQueriesCollection[queryIndex] = {
          ...newQueriesCollection[queryIndex],
          loading: false,
          error: undefined,
          data: payload.data
        };
        return {
          ...state,
          overview: {
            ...state.overview,
            queriesCollection: newQueriesCollection
          }
        };
      }
      return state;
    }
  )
];
